<template>
  <b-row class="mt-3">
    <b-col md="12">
      <div class="d-flex overflow-auto w-100">
        <table class="table">
          <thead>
            <tr>
              <th
                v-for="(col, index) in columns"
                :key="index"
                class="text-truncate"
                style="background-color: #334697; color: white"
                :class="col.style"
                >{{ col }}</th
              >
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(job, index) in maintenance.data"
              :key="index"
              :style="`background:${index % 2 != 0 ? 'white' : '#f5f5f5'}`"
            >
              <td class="text-truncate text-left">
                <b-badge variant="success" style="font-size: smaller">{{
                  job.vehicleName
                }}</b-badge>
              </td>
              <td class="text-left" style="width: 25%">
                <div class="text-primary text-xs">{{ job.jobName ?? '-' }}</div>
                <small
                  >Job Code: <strong>{{ job?.jobCode ?? '-' }}</strong></small
                >
              </td>
              <td class="text-left" style="width: 25%">
                <div class="text-primary text-xs">{{
                  job.equipmentName ?? '-'
                }}</div>
                <div class="mb-0">
                  <small
                    >Job Type:
                    <strong>{{ job.jobTypeName ?? '-' }}</strong></small
                  >
                </div>
                <div>
                  <small
                    >Job Class:
                    <strong>{{ job.jobClassName ?? '-' }}</strong></small
                  >
                </div>
              </td>
              <td class="text-truncate text-left" style="width: 13%">
                <div class="text-xs">{{ job.trigger }}</div>
                <small
                  >Int: <strong>{{ job.interval ?? '-' }}</strong></small
                >
              </td>
              <td class="text-truncate text-left"
                >{{
                  job.lastMaintenanceDate
                    ? moment(job.lastMaintenanceDate, 'DD-MM-YYYY').format(
                        'DD/MM/YYYY'
                      )
                    : '-'
                }}
                <div v-if="job.lastMaintenanceHours">
                  <small
                    >RH:
                    <strong>
                      {{ job.lastMaintenanceHours ?? '-' }}
                    </strong></small
                  >
                </div>
              </td>
              <td
                class="text-truncate text-left"
                v-if="loadPage === 'progress'"
              >
                <template v-if="job.trigger == 'CALENDAR'">
                  {{
                    job.dueDate
                      ? moment(job.dueDate, 'DD-MM-YYYY').format('DD/MM/YYYY')
                      : '-'
                  }}
                </template>
                <template v-else>
                  {{ job.dueDate ?? '-' }}
                </template>
                <div v-if="job.status == 'POSTPONE'">
                  <small>Postpone: </small>{{ '-' }}
                </div>
              </td>
              <td v-else class="text-truncate text-left"> - </td>
              <td
                class="text-truncate text-left"
                v-if="loadPage === 'progress'"
              >
                <template v-if="job.status === 'OVERDUE'">
                  <b-badge
                    :id="'popover-status' + index"
                    variant="danger"
                    class="text-left"
                    >{{ job.status }} <br />
                    <small>
                      {{
                        job.statusDetail && job.statusDetail.includes('days')
                          ? generateDayDurations(
                              parseInt(
                                job.statusDetail.replace('days', '').trim()
                              )
                            ).durationString
                          : job.statusDetail
                      }}
                    </small>
                  </b-badge>
                </template>
                <template v-else-if="job.status === 'TOWARDS'">
                  <b-badge :id="'popover-status' + index" variant="info"
                    >TOWARDS</b-badge
                  >
                </template>
                <template v-else-if="job.status === 'REVIEW'">
                  <b-badge :id="'popover-status' + index" variant="info"
                    >REVIEW</b-badge
                  >
                </template>
                <template v-else-if="job.status === 'APPROVE'">
                  <b-badge :id="'popover-status' + index" variant="success"
                    >APPROVE</b-badge
                  >
                </template>
                <template v-else-if="job.status === 'POSTPONE'">
                  <b-badge :id="'popover-status' + index" variant="warning"
                    >POSTPONE</b-badge
                  >
                </template>
                <template v-else-if="job.status === 'NEW'">
                  <b-badge :id="'popover-status' + index" variant="primary"
                    >ACTIVE</b-badge
                  >
                </template>
                <template v-else>
                  <b-badge variant="light">{{ job.status }}</b-badge>
                </template></td
              >
              <td>
                <b-dropdown
                  size="sm"
                  variant="link iq-bg-primary iq-border-radius-10"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <span
                      class="dropdown-toggle p-0"
                      id="dropdownMenuButton5"
                      data-toggle="dropdown"
                    >
                      Actions
                    </span>
                  </template>
                  <template v-if="loadPage === 'progress'">
                    <b-dropdown-item
                      size="sm"
                      href="#"
                      v-if="
                        canAdd &&
                        ['TOWARDS', 'OVERDUE', 'POSTPONE', 'NEW'].includes(
                          job.status
                        )
                      "
                      @click.prevent="
                        $emit('viewDetailMaintenance', {
                          id: job.id,
                          type: 'ON_MAINTENANCE',
                        })
                      "
                      variant="primary"
                      ><i class="fa fa-tasks"></i> Maintenance</b-dropdown-item
                    >
                    <b-dropdown-item
                      size="sm"
                      href="#"
                      v-if="['APPROVE'].includes(job.status) && canApprove"
                      variant="info"
                      @click.prevent="$emit('onApprove', job.id)"
                      ><i class="fa fa-thumbs-up"></i> Approve</b-dropdown-item
                    >
                    <b-dropdown-item
                      size="sm"
                      href="#"
                      v-if="['TOWARDS', 'OVERDUE', 'NEW'].includes(job.status)"
                      @click.prevent="$emit('onPostpone', job)"
                      variant="warning"
                      ><i class="fa fa-clock"></i> Postpone</b-dropdown-item
                    >
                    <b-dropdown-item
                      size="sm"
                      href="#"
                      v-if="
                        ['MAINTENANCE', 'REVIEW'].includes(job.status) &&
                        canReview
                      "
                      @click.prevent="$emit('onReview', job.id)"
                      variant="info"
                      ><i class="fa fa-search"></i> Review</b-dropdown-item
                    >
                    <b-dropdown-item
                      size="sm"
                      href="#"
                      v-if="['APPROVE', 'REVIEW'].includes(job.status)"
                      @click.prevent="
                        $emit('viewDetailMaintenance', {
                          id: job.id,
                          type: 'ON_MAINTENANCE',
                          isEdit: true,
                        })
                      "
                      variant="primary"
                      ><i class="fa fa-pen"></i> Edit</b-dropdown-item
                    >
                  </template>
                  <template v-else>
                    <b-dropdown-item
                      size="sm"
                      href="#"
                      @click.prevent="
                        $emit('viewDetailMaintenance', {
                          id: job.id,
                          type: 'VIEW_DETAIL',
                        })
                      "
                      ><i class="fa fa-eye mr-1"></i> Detail
                      Maintenance</b-dropdown-item
                    >
                  </template>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template v-if="!maintenance.isLoading && !maintenance.data?.length">
        <p class="text-black"> No data available </p>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ProgressList',
  props: {
    loadPage: {
      type: String,
      required: true,
      default: 'progress',
    },
    maintenance: {
      type: Object,
      default: () => {
        return {
          data: [],
          meta: null,
          isLoading: false,
        }
      },
    },
    canAdd: Boolean,
    canApprove: Boolean,
    canReview: Boolean,
  },
  data() {
    return {
      columnsProgress: [
        'Fleet Name',
        'Job Name',
        'Equipment Name',
        'Trigger',
        'Last Maintenance',
        'Due Date',
        'Status',
        'Action',
      ],
      columnsFinish: [
        'Fleet Name',
        'Job Name',
        'Equipment Name',
        'Trigger',
        'Last Maintenance',
        'Maintenance Date',
        'Action',
      ],
    }
  },
  computed: {
    columns() {
      if (this.loadPage === 'progress') {
        return this.columnsProgress
      } else {
        return this.columnsFinish
      }
    },
  },
  methods: {
    generateDayDurations(days) {
      let start = moment()
      let end = moment().add(days, 'days')
      let difference = moment(end).diff(moment(start))
      let duration = moment.duration(difference)
      let durationString = ''

      if (Math.round(duration.years()) > 0) {
        durationString += `${Math.round(duration.years())} years `
      }

      if (Math.round(duration.months()) > 0) {
        durationString += `${Math.round(duration.months())} months `
      }

      if (Math.round(duration.weeks()) > 0) {
        durationString += `${Math.round(duration.weeks())} weeks `
      }

      if (Math.round(duration.days()) > 0) {
        durationString += `${Math.round(duration.days())} days `
      }

      return {
        start,
        end,
        duration: difference / 1000,
        durationString,
      }
    },
  },
  mounted() {},
}
</script>

<style scoped>
.sticky-column {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
}
.column-1 {
  left: 0;
}
.column-2 {
  left: 2.4rem;
}
.column-3 {
  left: 9.4rem;
}

.custom {
  background-color: '#334697' !important;
  color: white !important;
}
.text-sm {
  font-size: 0.875rem !important;
}
.text-xs {
  font-size: 0.75 !important;
}
.font-bold {
  font-weight: 700 !important;
}
.font-semibold {
  font-weight: 600 !important;
}
</style>
